import { BatteryLow, LocateOff, Navigation2 } from "lucide-react";
import type { Member } from "../types";

function relativeTime(value: string | null) {
  if (!value) return "ยังไม่มีตำแหน่ง";
  const seconds = Math.max(
    0,
    Math.round((Date.now() - new Date(value).getTime()) / 1000),
  );
  if (seconds < 15) return "ตอนนี้";
  if (seconds < 60) return `${seconds} วิ`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} นาที`;
  return `${Math.floor(seconds / 3600)} ชม.`;
}

export function MemberRail({
  members,
  selectedId,
  onSelect,
}: {
  members: Member[];
  selectedId: string | null;
  onSelect: (member: Member) => void;
}) {
  return (
    <div className="member-rail" aria-label="สมาชิกในกลุ่ม">
      {members.map((member) => {
        const stale =
          !member.capturedAt ||
          Date.now() - new Date(member.capturedAt).getTime() > 2 * 60_000;
        return (
          <button
            type="button"
            className={`member-chip ${selectedId === member.id ? "active" : ""}`}
            key={member.id}
            onClick={() => onSelect(member)}
          >
            <span
              className="member-chip-avatar"
              style={{ "--avatar-color": member.avatarColor } as React.CSSProperties}
            >
              {member.name.slice(0, 2).toUpperCase()}
              <i className={stale ? "away" : "online"} />
            </span>
            <span className="member-chip-copy">
              <b>{member.name.split(" ")[0]}</b>
              <small>
                {!member.shareLocation ? (
                  <><LocateOff size={11} /> พักแชร์</>
                ) : member.battery != null && member.battery < 0.15 ? (
                  <><BatteryLow size={11} /> แบตต่ำ</>
                ) : (
                  <><Navigation2 size={10} /> {relativeTime(member.capturedAt)}</>
                )}
              </small>
            </span>
          </button>
        );
      })}
    </div>
  );
}
